import type { ReactNode } from "react";

import TypeBadge from "@/pages/Dashboard/components/TypeBadge";
import type { UnifiedRow } from "@/pages/Dashboard/shared";
import { cn } from "@/utils/cn";

interface UserReservationSectionProps {
  title: string;
  emptyText: string;
  rows: UnifiedRow[];
  headerAction?: ReactNode;
  onRowClick: (row: UnifiedRow) => void;
}

const UserReservationSection = ({
  title,
  emptyText,
  rows,
  headerAction,
  onRowClick,
}: UserReservationSectionProps) => (
  <div className="flex h-72 flex-col rounded-xl border border-gray-200 bg-white shadow-sm">
    <div className="flex shrink-0 items-center justify-between border-b border-gray-100 px-5 py-3">
      <h2 className="text-sm font-bold text-gray-800">{title}</h2>
      {headerAction}
    </div>
    <div className="divide-y divide-gray-50 overflow-y-auto">
      {rows.length === 0 ? (
        <div className="px-5 py-8 text-center text-sm text-gray-400">
          {emptyText}
        </div>
      ) : (
        rows.map(row => (
          <button
            key={row.key}
            type="button"
            onClick={() => onRowClick(row)}
            className="flex w-full items-center gap-3 rounded-lg px-5 py-3 text-left transition-all duration-150 hover:-translate-y-px hover:bg-gray-50 hover:shadow-md focus:outline-none"
          >
            <TypeBadge type={row.type} />
            <div className="flex min-w-0 flex-1 flex-col">
              <div className="flex items-center gap-2">
                <span className="w-16 shrink-0 text-sm font-medium tabular-nums text-gray-800">
                  {row.date}
                </span>
                <span className="text-xs text-gray-400">{row.time}</span>
              </div>
              <span className="truncate text-xs text-gray-400">
                {row.name} · {row.detail}
              </span>
            </div>
            <span
              className={cn(
                "shrink-0 rounded-full px-2 py-0.5 text-[10px] font-medium",
                row.statusClass,
              )}
            >
              {row.statusLabel}
            </span>
          </button>
        ))
      )}
    </div>
  </div>
);

export default UserReservationSection;
